var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarCancelation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 5h-3V3h-2v2h-12V3h-2v2h-3a2 2 0 00-2 2v7h26V7a2 2 0 00-2-2zm0 7h-22V7h3v3h2V7h12v3h2V7h3v5zm-10 15h-12V16h-2v11a2 2 0 002 2h12v-2zm0-5v2h-3v-2h3zm0-4v2h-3v-2h3zm-5 2v-2h-4v2h4zm0 2v2h-4v-2h4z",
    fill: "#54822B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#54822B",
    d: "M20.914 19l8.485 8.485-1.414 1.414-8.485-8.485z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#54822B",
    d: "M29.4 20.414l-8.486 8.485-1.414-1.414L27.986 19z"
  })));
}

export default SvgIconCalendarCancelation;